/* SHE Pack Component

    This component consists of all the she pack compoents that the user can user to naviagte to different options of the SHE Pack
*/

// -------------- React Components ----------
import React from "react";
import { Link } from "react-router-dom";



// ------------- Icons --------------

import { IoPeopleOutline } from "react-icons/io5";

import { AiOutlineFolderAdd } from "react-icons/ai"; // Icon -  Create File
import { AiOutlineFileAdd } from "react-icons/ai"; // Icon - create Template

import { IoIosAddCircleOutline, IoIosLink } from "react-icons/io";

import { CiPen } from "react-icons/ci";

import { VscGraph } from "react-icons/vsc";

import { CiEdit } from "react-icons/ci";

import { TbReportSearch } from "react-icons/tb";

// ------------ CSS File ------------ 
import '../../assets/css/Checklists.css';
import { FaRegBuilding } from "react-icons/fa";
import { GoArrowSwitch } from "react-icons/go";

const ComplianceManagementComponent = () => {

    const user = JSON.parse(sessionStorage.getItem('user'));

    

    return (

        <div className="component-container">

            <div className="manage-users-component-container">

                <div className="manage-users-header-component-container">

                    <div>
                        <h2>Section - <span className="secondary-color-paragraph">Compliance Tracker</span></h2>
                        <p>This section is dedicated to managing all aspects of the compliance tracker within the application.</p>
                    </div>

                </div>

                {/* Section - File and Template Manager   */}
                {(user.userRole !== 'user')  && (
                
                    <div className="main-pages-compartments-main-container">

                        <div className="manage-users-text-container">

                            <div>
                                <h2>File and Templates Management</h2>
                                <p>Efficiently manage SHE files and templates.</p>
                            </div>
                        
                        </div>

                        {/* Items - file and Template Manager */}
                        <div className="manage-users-feature-main-container">

                            {/* Link - Create SHE File */}
                            <Link className="link" to='/compliance-tracker/compliance-tracker-management/create-she-file'>

                                <div className='manage-users-feature-container'>

                                    <div className="feature-img-container">
                                        <AiOutlineFolderAdd className="feature-img"/>
                                    </div>

                                    <div className="feature-name-container">

                                        <h4>Create SHE File</h4>

                                    </div>

                                    <div className="feature-description-container">

                                        <p>
                                            To create a she file tailored to your requirements.
                                        </p>

                                    </div>

                                </div>
                                
                                </Link>

                                <Link className="link" to='/compliance-tracker/compliance-tracker-management/create-templates'>

                                <div className='manage-users-feature-container'>

                                    <div className="feature-img-container">
                                        <AiOutlineFileAdd className="feature-img"/>
                                    </div>

                                    <div className="feature-name-container">

                                        <h4>Create Templates</h4>

                                    </div>

                                    <div className="feature-description-container">

                                        <p>
                                            To create a templates for a SHE File tailored to your requirements
                                        </p>

                                    </div>

                                </div>
                                
                                </Link>

                               
                        
                        
                        </div>
                    </div>
                )}

                {/* Section - People Management   */}
                {(user.userRole === 'super admin' || user.userType === 'QA')  && (
                
                <div className="main-pages-compartments-main-container">

                    <div className="manage-users-text-container">

                        <div>
                            <h2>Quality Assurance</h2>
                            <p>Review and manage file submissions that are prepared for the Quality Assurance (QA) process. </p>
                        </div>
                    
                    </div>

                    {/* Items - file and Template Manager */}
                    <div className="manage-users-feature-main-container">

                        {/* Link - Create SHE File */}
                        <Link className="link" to='/compliance-tracker/quality-assurance/review-submissions'>

                            <div className='manage-users-feature-container'>

                                <div className="feature-img-container">
                                    <TbReportSearch   className="feature-img"/>
                                </div>

                                <div className="feature-name-container">

                                    <h4>QA - Review Consultant Submissions</h4>

                                </div>

                                <div className="feature-description-container">

                                    <p>
                                        Review and manage consultant submissions.
                                    </p>

                                </div>

                            </div>
                            
                            </Link>

                          
                    
                    </div>
                </div>
            )}

            

            {/* Section - People Management   */}
            {(user.userRole === 'super admin' || user.userRole === 'user')  && (
            
            <div className="main-pages-compartments-main-container">

                <div className="manage-users-text-container">

                    <div>
                        <h2>SHE File & Template Submissions</h2>
                        <p>Complete and submit SHE files and templates. </p>
                    </div>
                
                </div>

                {/* Items - file and Template Manager */}
                <div className="manage-users-feature-main-container">

                    {/* Link - Create SHE File */}
                    <Link className="link" to='/compliance-tracker/compliance-tracker-management/consultant-template-fill-in'>

                        <div className='manage-users-feature-container'>

                            <div className="feature-img-container">
                                <CiPen  className="feature-img"/>
                            </div>

                            <div className="feature-name-container">

                                <h4>Consultant Template Fill In</h4>

                            </div>

                            <div className="feature-description-container">

                                <p>
                                    To complete and submit a template.
                                </p>

                            </div>

                        </div>
                        
                        </Link>

                        {(user.userRole === 'super admin' || user.userRole === 'user')  && (

                            
                            <Link className="link" to='/compliance-tracker/people-management/assign-consultant'>

                                <div className='manage-users-feature-container'>

                                    <div className="feature-img-container">
                                        <IoIosLink  className="feature-img"/>
                                    </div>

                                    <div className="feature-name-container">

                                        <h4>Assign Template to Consultant</h4>

                                    </div>

                                    <div className="feature-description-container">

                                        <p>
                                            Assign a consultant or a company to a she file and templates
                                        </p>

                                    </div>

                                </div>
                            
                            </Link>

                        )}

                        

                      
                
                </div>
            </div>
        )}

            

             {/* Section - People Management   */}
             {(user.userRole === 'super admin' || user.userRole === 'user')  && (
                
                <div className="main-pages-compartments-main-container">

                    <div className="manage-users-text-container">

                        <div>
                            <h2>File and Template Viewer</h2>
                            <p>View files and documents with ease for quick access and reference..</p>
                        </div>
                    
                    </div>

                    {/* Items - file and Template Manager */}
                    <div className="manage-users-feature-main-container">

                        {/* Link - Create SHE File */}
                        <Link className="link" to='/compliance-tracker/file-and-template-viewer/view-template'>

                            <div className='manage-users-feature-container'>

                                <div className="feature-img-container">
                                    <VscGraph  className="feature-img"/>
                                </div>

                                <div className="feature-name-container">

                                    <h4>View Template Submissions</h4>

                                </div>

                                <div className="feature-description-container">

                                    <p>
                                        View all responses, percetnages, and scores for completed templates.
                                    </p>

                                </div>

                            </div>
                            
                            </Link>
                    </div>
                    
                </div>
            )}



                {/* Section - People Management   */}
                {(user.userRole === 'super admin' )  && (
                
                <div className="main-pages-compartments-main-container">

                    <div className="manage-users-text-container">

                        <div>
                            <h2>People Management</h2>
                            <p>Create, edit and manage users linked to compliance.</p>
                        </div>
                    
                    </div>

                    {/* Items - file and Template Manager */}
                    <div className="manage-users-feature-main-container">

                        {user.userRole === 'super admin'  && (
                                                <Link className="link" to='/createcompany'>
                        
                                                <div className='manage-users-feature-container'>
                        
                                                    <div className="feature-img-container">
                                                        <FaRegBuilding className="feature-img"/>
                                                    </div>
                        
                                                    <div className="feature-name-container">
                        
                                                        <h4>Create Company</h4>
                        
                                                    </div>
                        
                                                    <div className="feature-description-container">
                        
                                                        <p>
                                                            Create a checklist tailored to your requirements
                                                        </p>
                        
                                                    </div>
                        
                                                </div>
                                                
                                                </Link>
                                                )}
                        
                                                
                        
                                                {/* View Form */}
                                                <Link className="link" to='/people-management/add-department'>
                        
                                                {/* View form */}
                                                <div className='manage-users-feature-container'>
                        
                                                    <div className="feature-img-container">
                        
                                                        <IoIosAddCircleOutline className="feature-img"/>
                        
                                                    </div>
                        
                                                    <div className="feature-name-container">
                        
                                                        <h4>Add Department</h4>
                        
                                                    </div>
                        
                                                    <div className="feature-description-container">
                        
                                                        <p>
                                                            Add more departments to an existing company.
                                                        </p>
                        
                                                    </div>
                        
                                                </div>
                                                
                                                </Link>

                        {/* Link - Create SHE File */}
                        <Link className="link" to='/compliance-tracker/people-management/create-employee'>

                            <div className='manage-users-feature-container'>

                                <div className="feature-img-container">
                                    <IoPeopleOutline  className="feature-img"/>
                                </div>

                                <div className="feature-name-container">

                                    <h4>Create Employee</h4>

                                </div>

                                <div className="feature-description-container">

                                    <p>
                                        Create employee lists that belong to a company and department.
                                    </p>

                                </div>

                            </div>
                            
                        </Link>

                        {/* Link - Create SHE File */}
                        <Link className="link" to='/compliance-tracker/people-management/edit-employee'>

                            <div className='manage-users-feature-container'>

                                <div className="feature-img-container">
                                    <CiEdit  className="feature-img"/>
                                </div>

                                <div className="feature-name-container">

                                    <h4>Edit Employee</h4>

                                </div>

                                <div className="feature-description-container">

                                    <p>
                                        Edit employee details, add or remove employees associated to a company and department
                                    </p>

                                </div>

                            </div>
                            
                        </Link>

                     
                        <Link className="link" to='/compliance-tracker/people-management/move-delete-employee'>

                            <div className='manage-users-feature-container'>

                                <div className="feature-img-container">
                                    <GoArrowSwitch  className="feature-img"/>
                                </div>

                                <div className="feature-name-container">

                                    <h4>Move/Delete Employee</h4>

                                </div>

                                <div className="feature-description-container">

                                    <p>
                                        To move an employee to another department or delete an employee from the system.
                                    </p>

                                </div>

                            </div>
                            
                        </Link>

                    
                    </div>
                </div>
            )}


            </div>

        </div>

    )
}

export default ComplianceManagementComponent